import { render, staticRenderFns } from "./tencent.vue?vue&type=template&id=0b52fed0"
import script from "./tencent.vue?vue&type=script&lang=js"
export * from "./tencent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports